export const AI_FEATURE_GRADIENT = 'linear-gradient(277deg, #5f5fff, #f05fff 50%, #ff5b98)';
